import { Sdk } from '@serversgg/sdk-js'

const sdkConfig = {
  timeout: 10,
}

if (process.env.SERVERSGG_API_URL) {
  sdkConfig.baseUrl = process.env.SERVERSGG_API_URL
}

const sdk = (new Sdk(sdkConfig))
  .setAsDefault()

export default sdk
